/** Dispatched when the native app menu requests the About dialog. */
export const CURVA_OPEN_ABOUT_EVENT = "curva:open-about";
